import { trackGiddyUp, disposeTrackGiddyUp } from './analytics'
import { registerOddsSideEffects, deregisterOddsSideEffects } from './odds.side-effects'
import {
  registerQuaddieTipsSideEffects,
  deregisterQuaddieTipsSideEffects,
} from './quaddie-tips-side-effects'

export function registerSideEffects() {
  registerOddsSideEffects()
  registerQuaddieTipsSideEffects()
  trackGiddyUp()
}

export function deregisterSideEffects() {
  deregisterOddsSideEffects()
  deregisterQuaddieTipsSideEffects()
  disposeTrackGiddyUp()
}
